var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('demo-section',[_c('demo-block',{attrs:{"title":"导航"}},[_c('div',{staticClass:"px-3"},[_c('van-button',{attrs:{"type":"primary","block":""},on:{"click":_vm.doScan}},[_vm._v("开启导航\n      ")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }